"use strict";

var _classCallCheck = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _inherits = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var _createSuper = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createSuper");

var HTMLElementImpl = require("./HTMLElement-impl").implementation;

var _require = require("../helpers/form-controls"),
    isDisabled = _require.isDisabled,
    formOwner = _require.formOwner;

var DefaultConstraintValidationImpl = require("../constraint-validation/DefaultConstraintValidation-impl").implementation;

var _require2 = require("../../utils"),
    mixin = _require2.mixin;

var _require3 = require("../helpers/form-controls"),
    getLabelsForLabelable = _require3.getLabelsForLabelable;

var HTMLButtonElementImpl = /*#__PURE__*/function (_HTMLElementImpl) {
  _inherits(HTMLButtonElementImpl, _HTMLElementImpl);

  var _super = _createSuper(HTMLButtonElementImpl);

  function HTMLButtonElementImpl(args, privateData) {
    var _this;

    _classCallCheck(this, HTMLButtonElementImpl);

    _this = _super.call(this, args, privateData);
    _this._customValidityErrorMessage = "";
    _this._labels = null;
    _this._hasActivationBehavior = true;
    return _this;
  }

  _createClass(HTMLButtonElementImpl, [{
    key: "_activationBehavior",
    value: function _activationBehavior() {
      var form = this.form;

      if (form && !isDisabled(this)) {
        if (this.type === "submit") {
          form._doSubmit();
        }

        if (this.type === "reset") {
          form._doReset();
        }
      }
    }
  }, {
    key: "_getValue",
    value: function _getValue() {
      var valueAttr = this.getAttributeNS(null, "value");
      return valueAttr === null ? "" : valueAttr;
    }
  }, {
    key: "_barredFromConstraintValidationSpecialization",
    value: function _barredFromConstraintValidationSpecialization() {
      return this.type === "reset" || this.type === "button";
    }
  }, {
    key: "labels",
    get: function get() {
      return getLabelsForLabelable(this);
    }
  }, {
    key: "form",
    get: function get() {
      return formOwner(this);
    }
  }, {
    key: "type",
    get: function get() {
      var typeAttr = (this.getAttributeNS(null, "type") || "").toLowerCase();

      switch (typeAttr) {
        case "submit":
        case "reset":
        case "button":
          return typeAttr;

        default:
          return "submit";
      }
    },
    set: function set(v) {
      v = String(v).toLowerCase();

      switch (v) {
        case "submit":
        case "reset":
        case "button":
          this.setAttributeNS(null, "type", v);
          break;

        default:
          this.setAttributeNS(null, "type", "submit");
          break;
      }
    }
  }]);

  return HTMLButtonElementImpl;
}(HTMLElementImpl);

mixin(HTMLButtonElementImpl.prototype, DefaultConstraintValidationImpl.prototype);
module.exports = {
  implementation: HTMLButtonElementImpl
};